// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Debug_Trace = require("../Debug.Trace/index.js");
var RevMap = (function () {
    function RevMap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RevMap.create = function (value0) {
        return function (value1) {
            return new RevMap(value0, value1);
        };
    };
    return RevMap;
})();
var values = function (dictOrd) {
    return function (v) {
        return Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.values(v.value0));
    };
};
var uniqueValues = function (dictOrd) {
    return function (v) {
        return Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (v1) {
            return function (acc) {
                return function (v2) {
                    return Data_Array.cons(v1)(acc);
                };
            };
        })([  ])(v.value1);
    };
};
var lookupReverse = function (dictOrd) {
    return function (v) {
        return function (v1) {
            return Data_Map_Internal.lookup(dictOrd)(v)(v1.value1);
        };
    };
};
var lookup = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Map_Internal.lookup(dictOrd)(k)(v.value0);
        };
    };
};
var foldableRevMap = new Data_Foldable.Foldable(function (dictMonoid) {
    return function (f) {
        return function (v) {
            return Data_Foldable.foldMap(Data_Map_Internal.foldableMap)(dictMonoid)(f)(v.value0);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_Foldable.foldl(Data_Map_Internal.foldableMap)(f)(z)(v.value0);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_Foldable.foldr(Data_Map_Internal.foldableMap)(f)(z)(v.value0);
        };
    };
});
var foldableWithIndexRevMap = new Data_FoldableWithIndex.FoldableWithIndex(function () {
    return foldableRevMap;
}, function (dictMonoid) {
    return function (f) {
        return function (v) {
            return Data_FoldableWithIndex.foldMapWithIndex(Data_Map_Internal.foldableWithIndexMap)(dictMonoid)(f)(v.value0);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap)(f)(z)(v.value0);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_FoldableWithIndex.foldrWithIndex(Data_Map_Internal.foldableWithIndexMap)(f)(z)(v.value0);
        };
    };
});
var flat = Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (k) {
    return function (a) {
        return function (v) {
            return Data_Array.cons({
                k: k,
                v: v
            })(a);
        };
    };
})([  ]);
var spyRev = function (v) {
    var v1 = Debug_Trace.spy()("rm")({
        l: flat(v.value0),
        r: flat(v.value1)
    });
    return v;
};
var empty = function (dictOrd) {
    return function (dictOrd1) {
        return new RevMap(Data_Map_Internal.empty, Data_Map_Internal.empty);
    };
};
var del = function (dictEq) {
    return function (x) {
        return function (xs) {
            var v = Data_Array.elemIndex(dictEq)(x)(xs);
            if (v instanceof Data_Maybe.Nothing) {
                return new Data_Maybe.Just(xs);
            };
            if (v instanceof Data_Maybe.Just) {
                var v1 = Data_Array.deleteAt(v.value0)(xs);
                if (v1 instanceof Data_Maybe.Just && v1.value0.length === 0) {
                    return Data_Maybe.Nothing.value;
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Data_Maybe.Nothing.value;
                };
                return v1;
            };
            throw new Error("Failed pattern match at Data.RevMap (line 110, column 12 - line 115, column 38): " + [ v.constructor.name ]);
        };
    };
};
var cleanupDeleted = function (dictOrd) {
    return function (dictOrd1) {
        return function (k) {
            return function (mayv) {
                return function (m) {
                    return Data_Maybe.fromMaybe(m)(Control_Bind.bind(Data_Maybe.bindMaybe)(mayv)(function (v) {
                        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Map_Internal.alter(dictOrd1)(function (xs) {
                            return Control_Bind.bind(Data_Maybe.bindMaybe)(xs)(del(dictOrd.Eq0())(k));
                        })(v)(m));
                    }));
                };
            };
        };
    };
};
var $$delete = function (dictOrd) {
    return function (dictOrd1) {
        return function (k) {
            return function (v) {
                return new RevMap(Data_Map_Internal["delete"](dictOrd)(k)(v.value0), cleanupDeleted(dictOrd)(dictOrd1)(k)(Data_Map_Internal.lookup(dictOrd)(k)(v.value0))(v.value1));
            };
        };
    };
};
var insert = function (dictOrd) {
    return function (dictOrd1) {
        return function (k) {
            return function (v) {
                return function (v1) {
                    return RevMap.create(Data_Map_Internal.insert(dictOrd)(k)(v)(v1.value0))(cleanupDeleted(dictOrd)(dictOrd1)(k)(Data_Map_Internal.lookup(dictOrd)(k)(v1.value0))(Data_Map_Internal.insertWith(dictOrd1)(Data_Semigroup.append(Data_Semigroup.semigroupArray))(v)(Data_Array.singleton(k))(v1.value1)));
                };
            };
        };
    };
};
var fromFoldable = function (dictOrd) {
    return function (dictOrd1) {
        return function (dictFoldable) {
            return function (xs) {
                return Data_Foldable.foldl(dictFoldable)(function (m) {
                    return function (v) {
                        return insert(dictOrd)(dictOrd1)(v.value0)(v.value1)(m);
                    };
                })(empty(dictOrd)(dictOrd1))(xs);
            };
        };
    };
};
var fromFoldableWithIndex = function (dictOrd) {
    return function (dictOrd1) {
        return function (dictFoldableWithIndex) {
            return Data_FoldableWithIndex.foldlWithIndex(dictFoldableWithIndex)(function (k) {
                return function (m) {
                    return function (v) {
                        return insert(dictOrd)(dictOrd1)(k)(v)(m);
                    };
                };
            })(empty(dictOrd)(dictOrd1));
        };
    };
};
module.exports = {
    empty: empty,
    insert: insert,
    "delete": $$delete,
    lookup: lookup,
    lookupReverse: lookupReverse,
    fromFoldable: fromFoldable,
    fromFoldableWithIndex: fromFoldableWithIndex,
    values: values,
    uniqueValues: uniqueValues,
    spyRev: spyRev,
    foldableRevMap: foldableRevMap,
    foldableWithIndexRevMap: foldableWithIndexRevMap
};
